import type { IndentStyle } from '../types';

/**
 * Returns the string to insert for one level of indentation.
 */
export function getIndentString(style: IndentStyle): string {
  switch (style) {
    case 'tab':
      return '\t';
    case '2space':
      return '  ';
    case '4space':
      return '    ';
  }
}

/**
 * Returns the number of characters that constitute one indentation level.
 */
export function getIndentWidth(style: IndentStyle): number {
  switch (style) {
    case 'tab':
      return 1;
    case '2space':
      return 2;
    case '4space':
      return 4;
  }
}

/**
 * Determines how many characters to remove from the start of a line
 * when unindenting, based on the preferred indent style.
 * Prioritizes the configured style but falls back to detecting other patterns.
 */
export function getUnindentChars(lineText: string, preferredStyle: IndentStyle): number {
  const indentStr = getIndentString(preferredStyle);

  // First, check if line starts with the preferred indent
  if (lineText.startsWith(indentStr)) {
    return indentStr.length;
  }

  // Fallback: detect and remove any common indentation pattern
  // This ensures unindent works even on files with mixed indentation
  if (lineText.startsWith('\t')) {
    return 1;
  } else if (lineText.startsWith('    ')) {
    return 4;
  } else if (lineText.startsWith('  ')) {
    return 2;
  } else if (lineText.startsWith(' ')) {
    return 1;
  }

  return 0;
}
